import React from "react";
import PropTypes from "prop-types";
import FontAwesome from "react-fontawesome";

import "../schools/Header.css";

class Header extends React.Component {
    static permission = "Admin.SpecialGroups";

    render() {
        const { readonly } = this.props;
        return (
            <div className="admin-school-header">
                <button onClick={this.props.onAdd} disabled={readonly}>
                    <FontAwesome name="plus" />
                    <span className="title">ADD SPECIAL GROUP</span>
                </button>
                <button onClick={this.props.onImport} disabled={readonly} style={{ marginLeft: "12px" }}>
                    <FontAwesome name="upload" />
                    <span className="title">BULK IMPORT</span>
                </button>
            </div>
        );
    }
}

Header.propTypes = {
    onAdd: PropTypes.func.isRequired,
    onImport: PropTypes.func.isRequired,
    readonly: PropTypes.bool.isRequired,
};

export default Header;
